/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_Read_OnlyInputs */

const es_components_credentials_permissions_read_only = /** @type {(inputs: Components_Credentials_Permissions_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo Lectura`)
};

const en_components_credentials_permissions_read_only = /** @type {(inputs: Components_Credentials_Permissions_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read Only`)
};

/**
* | output |
* | --- |
* | "Read Only" |
*
* @param {Components_Credentials_Permissions_Read_OnlyInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_read_only = /** @type {((inputs?: Components_Credentials_Permissions_Read_OnlyInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_Read_OnlyInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_read_only(inputs)
	return en_components_credentials_permissions_read_only(inputs)
});
export { components_credentials_permissions_read_only as "components.credentials.permissions.read_only" }